export default __webpack_public_path__ + "static/media/carousel2.a4d4ee63.jpg";